export default __webpack_public_path__ + "static/media/oxygen2.490c910c.png";